// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TooltipOpener{color:#7cb342;cursor:pointer;display:inline-block;font-size:1.125rem;margin-top:-.28125rem;max-width:1.125rem;width:1.125rem}.TooltipOpener--hasText{max-width:none;width:auto}svg.TooltipOpener__questionMarkWrapper{color:#d9d9d9;cursor:pointer}.TooltipOpener__text{-webkit-text-decoration:underline;text-decoration:underline}.TooltipOpener--primary>.TooltipOpener__questionMarkWrapper{border-color:#7cb342;color:#7cb342}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
